import React, { useState, useEffect } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom"; // ← Add this
import "react-toastify/dist/ReactToastify.css";

// ⏱ Format timestamp like your example
const getFormattedTimestamp = () => {
  const now = new Date();
  return (
    now.getDate() +
    "/" +
    (now.getMonth() + 1) +
    "/" +
    now.getFullYear() +
    " @ " +
    now.getHours() +
    ":" +
    now.getMinutes() +
    ":" +
    now.getSeconds()
  );
};

const Form = () => {
    const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0); // show navbar
  }, []);

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    company: "",
    designation: "",
    occupation: "",
    industry: "",
    country: "",
    age: "",
    timestamp: getFormattedTimestamp(),
  });

  const colRef = collection(db, "japanSummitRSVP");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const fullName = `${form.firstName} ${form.lastName}`
        .split(" ")
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
        .join(" ");
      const cleanedEmail = form.email.toLowerCase();

      await addDoc(colRef, {
        ...form,
        fullName,
        email: cleanedEmail,
        timestamp: getFormattedTimestamp(),
      });

      toast.success("🎉 Registration successful!");
      setForm({
        firstName: "",
        lastName: "",
        email: "",
        company: "",
        designation: "",
        occupation: "",
        industry: "",
        country: "",
        age: "",
        timestamp: getFormattedTimestamp(),
      });
    } catch (err) {
      toast.error("❌ Submission failed. Please try again.");
    }
  };

  const countries = ["Singapore", "Japan", "United States", "United Kingdom", "China", "India"];
  const designations = ["Executive Class", "Board Member Class", "Director Class", "Chief Class", "General Manager Class", "Section Manager Class", "General Staff", "Contract Staff", "Temporary Staff", "Others"];
  const occupations = ["Corporate Management / Board Member", "Business Planning and Development", "Public Relations / Promotion", "General Affairs / HR", "Materials / Procurement", "Finance & Accounting", "General Office", "IT, IT Systems", "Planning, Market Study, Marketing", "Sales", "Production, Manufacturing", "Logistics / Shipping", "Engineering & Design", "Research & Development", "Editing, Compiling, Production", "Architecture / Construction", "Medical", "Accounting", "Legal", "Education / Teaching"];
  const industries = ["Agriculture & Mining", "Construction", "Automotive & Transportation", "Electronics", "Machinery", "Materials", "Energy", "Food, Drug & Cosmetics", "Other Manufacturing", "Wholesale, Retail & Commerce (incl. Trading Companies)", "Finance, Securities, Insurance", "Real Estate", "Communication Services", "Information Technology, SI, Software", "Shipping", "Consulting, Accounting, Legal", "Broadcast, Publishing, Advertisement, Media", "Government Employee (excl. Teachers)", "Education & Learning Support", "Medical", "Nursing, Caretaking & Welfare", "Restaurant & Hospitality", "Personnel Services/HR", "Travel"];
  const ages = ["20s", "30s", "40s", "50s", "60s", "70s+"];

  return (
    <div className="bg-white py-20 px-4 max-w-4xl mx-auto lato">
        <button
  onClick={() => navigate(-1)}
  className="text-lg text-[#193d66] underline mb-4 hover:text-[#102d4d] transition"
>
  ← Back
</button>
      <h1 className="text-4xl bebas mb-10 text-center text-[#193d66]">Japan Summit RSVP</h1>
      <form onSubmit={console.log("congrats")} className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <input name="firstName" placeholder="First Name" value={form.firstName} onChange={handleChange} className="border p-3 rounded" required />
        <input name="lastName" placeholder="Last Name" value={form.lastName} onChange={handleChange} className="border p-3 rounded" required />
        <input name="email" type="email" placeholder="Email" value={form.email} onChange={handleChange} className="border p-3 rounded col-span-2" required />
        <input name="company" placeholder="Company / Organization Name" value={form.company} onChange={handleChange} className="border p-3 rounded col-span-2" required />

        <select name="designation" value={form.designation} onChange={handleChange} className="border p-3 rounded col-span-2" required>
          <option value="">Designation / Position</option>
          {designations.map((d, i) => <option key={i}>{d}</option>)}
        </select>

        <select name="occupation" value={form.occupation} onChange={handleChange} className="border p-3 rounded col-span-2" required>
          <option value="">Occupation</option>
          {occupations.map((o, i) => <option key={i}>{o}</option>)}
        </select>

        <select name="industry" value={form.industry} onChange={handleChange} className="border p-3 rounded col-span-2" required>
          <option value="">Industry</option>
          {industries.map((i, idx) => <option key={idx}>{i}</option>)}
        </select>

        <select name="country" value={form.country} onChange={handleChange} className="border p-3 rounded col-span-2" required>
          <option value="">Country</option>
          {countries.map((c, idx) => <option key={idx}>{c}</option>)}
        </select>

        <select name="age" value={form.age} onChange={handleChange} className="border p-3 rounded col-span-2" required>
          <option value="">Age</option>
          {ages.map((a, i) => <option key={i}>{a}</option>)}
        </select>

        <button type="submit" className="col-span-2 mt-6 bg-[#193d66] text-white p-3 rounded hover:bg-[#102d4d] transition">Submit</button>
      </form>
    </div>
  );
};

export default Form;
